export default function ImageConvertionDefault(ImageUrl ,  width , height) {
    if (ImageUrl == null){
        ImageUrl = "https://nonprod-media.webdunia.com/public_html/app-logo/en-logo.png";

    }
    return ImageUrl;
    if(ImageUrl.includes('http:')){
        ImageUrl =  ImageUrl.replace(/^http:\/\//i, 'https://');
    }
width = (typeof width == "undefined") ? ""  : width ;
height = (typeof height == "undefined") ? ""  : height ;
//outType = (outType =! "undefined") ? outType  : "webp" ;      

var convertionUrl = "https://wdimage.webdunia.com/image-conversion/process2?url="+ImageUrl+"&w="+width+"&h="+height+"&outtype=webp";
//var convertionUrl = "https://wdimage.webdunia.com/image-conversion/process?url="+ImageUrl+"&outtype=webp";

return convertionUrl;
}
export  function ImageConvertionDefault1(ImageUrl) { 
    if(ImageUrl.includes('http:')){
        ImageUrl =  ImageUrl.replace(/^http:\/\//i, 'https://');
    }
var convertionUrl = "https://wdimage.webdunia.com/image-conversion/process?url="+ImageUrl+"&outtype=webp";
return convertionUrl;
} 
